module.exports = __webpack_public_path__ + "static/img/team_member_scott.9a11df34.png";